import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root',
})
export class HttpService {

  apiUrl = environment.baseUrl + environment.apiVersion;

  constructor(private http: HttpClient) {
  }

  httpOptions = {
    // headers: new HttpHeaders({
    //   'Content-Type': 'application/json'
    // })
  };
  
  ngOnInit(): void {
  }

  post(url: string, data = {}): Observable<any | any[]> {
    return this.http.post(this.apiUrl + url, data,this.httpOptions);
  }

  patch(url: string, data = {}): Observable<any | any[]> {
    return this.http.patch(this.apiUrl + url, data,this.httpOptions);
  }

  put(url: string, data = {}): Observable<any | any[]> {
    return this.http.put(this.apiUrl + url, data,this.httpOptions);
  }

  get(url: string): Observable<any | any[]> {
    return this.http.get(this.apiUrl + url,this.httpOptions);
  }

  delete(url: string): Observable<any | any[]> {
    return this.http.delete(this.apiUrl + url,this.httpOptions);
  }
}
